import { render, staticRenderFns } from "./RecordTaskDrawer.vue?vue&type=template&id=09c54bd2&scoped=true"
import script from "./RecordTaskDrawer.vue?vue&type=script&lang=js"
export * from "./RecordTaskDrawer.vue?vue&type=script&lang=js"
import style0 from "./RecordTaskDrawer.vue?vue&type=style&index=0&id=09c54bd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c54bd2",
  null
  
)

export default component.exports